import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, Container, VStack, Text, Box, Flex } from '@chakra-ui/react';

import { generateSectionId } from '@rsc/ui-components/dept/utils/generateSectionId';
import ContactForm from '@rsc/ui-components/dept/molecules/ContactForm';
import Image from '@rsc/ui-components/tailwind/Image';
import { cn } from '@rsc/tailwind-base/utils';

export default function FormPress({ block, siteSettings }) {
  const theme = useTheme();
  const { copy, headline, images } = block;

  const imageConfigs = [
    'w-[12.5rem] top-20 left-8 lg:w-[17.5rem] lg:top-0 lg:-left-4',
    'w-[6.1rem] top-8 right-[20%] lg:w-[8.75rem] lg:-top-4 lg:right-56',
    'w-[6.1rem] top-52 right-8 lg:w-[8.75rem] lg:top-32 lg:right-0',
    'w-[12.4rem] bottom-12 right-12 lg:w-[17.5rem] lg:-bottom-12 lg:right-32',
    'w-[6.1rem] bottom-48 left-8 lg:w-[8.75rem] lg:bottom-4 lg:-left-16',
  ];

  return (
    <Container
      {...generateSectionId(block)}
      py={{
        base: '20rem',
        lg: 24,
      }}
      bgImg={theme.images.cloudBackground}
      bgRepeat="no-repeat"
      bgPosition="center"
      pos="relative"
      overflowX="hidden"
      w="full"
    >
      <Flex align="center" justify="space-between" gap={32}>
        <VStack
          align="start"
          w={{ base: 'full', lg: '28rem' }}
          minW={{ base: 'full', lg: '28rem' }}
          zIndex={1}
        >
          <Text as="h2" textStyle="h2" color="brand.ink" mb={6}>
            {headline}
          </Text>
          <Text mb={10}>{copy}</Text>

          <ContactForm brandEmail={siteSettings?.contactEmail} />
        </VStack>
        <Box
          pos={{ base: 'initial', lg: 'relative' }}
          flex={1}
          alignSelf="stretch"
          zIndex={0}
          maxW="42rem"
          minW="41rem"
        >
          {images.map((image, ix) => (
            <Image
              className={cn('rounded-lg absolute', imageConfigs[ix])}
              key={image._key}
              sanityImage={image}
              sanityRole="presentation"
            />
          ))}
        </Box>
      </Flex>
    </Container>
  );
}

FormPress.propTypes = {
  block: PropTypes.shape({
    _key: PropTypes.string.isRequired,
    _type: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        asset: PropTypes.shape({
          _type: PropTypes.string,
        }).isRequired,
        _key: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,
  }).isRequired,
  siteSettings: PropTypes.shape({
    contactEmail: PropTypes.string.isRequired,
  }).isRequired,
};
